import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import auth from "../../../core/auth";
//import $ from "jquery";
import GridItemView from "./gridView";
import Mqtt_statusBar from "../../../mqtt/mqtt_statusbar";
const appparameters = require("../../../core/common.jsx");

export default function GridView(props) {
  const [loading, setLoading] = useStateIfMounted(true);
  const lebanonDate = new Date().toLocaleString("en-US", {
    timeZone: "Asia/Beirut",
  });
  const [state, setState] = useStateIfMounted({
    sites: [],
  });

  const fetchData = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(auth.getUserData()),
    };

    fetch(
      appparameters.backend_app_url + "/frontend/getacountcontacts",
      requestOptions,
    )
      .then((response) => response.json())
      .then((responseData) => {
        setState({
          sites: responseData,
        });
        setLoading(false);
      })
      .catch((error) => console.warn(error));
  };

  useEffect(() => {
    fetchData(); // Initial fetch

    const intervalId = setInterval(
      () => {
        fetchData(); // Fetch data every 5 minutes
      },
      6 * 60 * 1000,
    ); // 5 minutes in milliseconds

    return () => {
      clearInterval(intervalId); // Cleanup the interval on component unmount
    };
  }, []);

  const calculateLastSeen = (lastSeenInSeconds) => {
    const currentTimestamp = Math.floor(Date.now() / 1000); // Current time in UTC seconds
    const timeDifference = currentTimestamp - lastSeenInSeconds;

    const secondsInMinute = 60;
    const secondsInHour = 60 * secondsInMinute;
    const secondsInDay = 24 * secondsInHour;
    const secondsInMonth = 30 * secondsInDay;
    const secondsInYear = 365 * secondsInDay;

    if (timeDifference < 6 * secondsInMinute) {
      return "Online";
    } else if (timeDifference < secondsInHour) {
      const minutesAgo = Math.floor(timeDifference / secondsInMinute);
      return `${minutesAgo} ${minutesAgo === 1 ? "minute" : "minutes"} ago`;
    } else if (timeDifference < secondsInDay) {
      const hoursAgo = Math.floor(timeDifference / secondsInHour);
      return `${hoursAgo} ${hoursAgo === 1 ? "hour" : "hours"} ago`;
    } else if (timeDifference < secondsInMonth) {
      const daysAgo = Math.floor(timeDifference / secondsInDay);
      return `${daysAgo} ${daysAgo === 1 ? "day" : "days"} ago`;
    } else if (timeDifference < secondsInYear) {
      const monthsAgo = Math.floor(timeDifference / secondsInMonth);
      return `${monthsAgo} ${monthsAgo === 1 ? "month" : "months"} ago`;
    } else {
      const yearsAgo = Math.floor(timeDifference / secondsInYear);
      return `${yearsAgo} ${yearsAgo === 1 ? "year" : "years"} ago`;
    }
  };

  /*const calculateLastSeen = (lastSeenInSeconds) => {
    const currentTimestamp = Math.floor(new Date(lebanonDate).getTime() / 1000);
    const timeDifference = currentTimestamp - lastSeenInSeconds;

    const secondsInMinute = 60;
    const secondsInHour = 60 * secondsInMinute;
    const secondsInDay = 24 * secondsInHour;
    const secondsInMonth = 30 * secondsInDay;
    const secondsInYear = 365 * secondsInDay;

    if (timeDifference < 6 * secondsInMinute) {
      return "Online";
    } else if (timeDifference < secondsInHour) {
      const minutesAgo = Math.floor(timeDifference / secondsInMinute);
      return `${minutesAgo} ${minutesAgo === 1 ? "minute" : "minutes"} ago`;
    } else if (timeDifference < secondsInDay) {
      const hoursAgo = Math.floor(timeDifference / secondsInHour);
      return `${hoursAgo} ${hoursAgo === 1 ? "hour" : "hours"} ago`;
    } else if (timeDifference < secondsInMonth) {
      const daysAgo = Math.floor(timeDifference / secondsInDay);
      return `${daysAgo} ${daysAgo === 1 ? "day" : "days"} ago`;
    } else if (timeDifference < secondsInYear) {
      const monthsAgo = Math.floor(timeDifference / secondsInMonth);
      return `${monthsAgo} ${monthsAgo === 1 ? "month" : "months"} ago`;
    } else {
      const yearsAgo = Math.floor(timeDifference / secondsInYear);
      return `${yearsAgo} ${yearsAgo === 1 ? "year" : "years"} ago`;
    }
  };*/

  if (loading) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading grid view ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else if (state.sites.length > 0) {
    return (
      <div className="col">
        <Mqtt_statusBar />
        <div className="row">
          {state.sites.map((site) => (
            <GridItemView
              key={site.sitedetails[0]["_id"]}
              index={site.sitedetails[0]["_id"]}
              siteId={site.sitedetails[0]["Surf ID"]}
              siteInformation={site["location_name"]}
              siteDescription={site["description"]}
              hardwareversion={site.sitedetails[0]["Hardware Version"]}
              softwareversion={site.sitedetails[0]["Software Version"]}
              revisionnumber={site.sitedetails[0]["Revision Number"]}
              serialnumber={site.sitedetails[0]["Serial Number"]}
              type={site.sitedetails[0]["Type"]}
              SDPresence={site.sitedetails[0]["SD Presence"]}
              mac={site.sitedetails[0]["Mac"]}
              latitude={site["latitude"]}
              longitude={site["longitude"]}
              mail={site["mail"]}
              subtype={site.sitedetails[0]["SubType"]}
              userpass={site.sitedetails[0]["Surf Password"]}
              clientpass={site.sitedetails[0]["Client Password"]}
              seniorpass={site.sitedetails[0]["Senior Password"]}
              saspass={site.sitedetails[0]["SAS Password"]}
              designtype={site.sitedetails[0]["Design Type"]}
              timezone={site.sitedetails[0]["TimeZone"]}
              lastseen={
                site.sitedetails[0]["Lastseen"] != undefined
                  ? calculateLastSeen(site.sitedetails[0]["Lastseen"])
                  : "N/A"
              }
              fu={site.sitedetails[0]["Firmware Upgrade"]}
              lr={site.sitedetails[0]["Log Retrieve"]}
              fl={site.sitedetails[0]["Faults Log"]}
              fr={site.sitedetails[0]["Fault Reset"]}
              entered_pass={site["entered_pass"]}
              status="N/A"
              parentPropsHistory={props.history}
            />
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className="container">
        <div>
          <img src={require("./../../../images/sadface.svg")} />
          <h6 />
          <h6>Empty account</h6>
          <h7>Click add site above to add a new device</h7>
        </div>
      </div>
    );
  }
}
